/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
import { AppRoute, FmtPage } from '../../shared/constants/route';

const FMT_PAGES = new Set<string>(Object.values(FmtPage));

export function fmtRoute(scenarioId: string, page: FmtPage = FmtPage.Overview): string[] {
	return ['/', AppRoute.FinancialModeling, scenarioId, page];
}

export function isFmtPage(segment: string | undefined): segment is FmtPage {
	return segment != null && FMT_PAGES.has(segment);
}

/** Parses `/financial-modeling/:scenarioId/:page` from a router URL. */
export function parseFmtUrl(url: string): { scenarioId: string | null; page: FmtPage | null } {
	const segments = url.split('?')[0].split('/').filter(Boolean);
	if (segments[0] !== AppRoute.FinancialModeling) {
		return { scenarioId: null, page: null };
	}
	const scenarioId = segments[1] ?? null;
	const page = isFmtPage(segments[2]) ? segments[2] : null;
	return { scenarioId, page };
}

export function getFmtPageFromUrl(url: string): FmtPage | null {
	return parseFmtUrl(url).page;
}

export function isFmtRoute(url: string): boolean {
	return url.split('?')[0].split('/').filter(Boolean)[0] === AppRoute.FinancialModeling;
}
